import { render } from "./RequesterBadge.vue?vue&type=template&id=a23452a8&scoped=true"
import script from "./RequesterBadge.vue?vue&type=script&lang=js"
export * from "./RequesterBadge.vue?vue&type=script&lang=js"

import "./RequesterBadge.vue?vue&type=style&index=0&id=a23452a8&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23452a8"]])

export default __exports__